import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../CoreWrappers/Button';

const Module = ({icon, label, onClick}) => {
	const props = {
		onClick,
		svg: icon,
		label,
		title: label,
		className: 'module-label',
		variant: 'secondary'
	};

	return <Button {...props} />;
};

Module.propTypes = {};

Module.defaultProps = {};

export default Module;
